import { ChildParentInvite } from "@seneca/parents-service-types";

type ConnectionStatus = "connected" | "pending" | "rejected" | undefined;

export type ConnectedParentType = {
  userId: string;
  email: string;
  status: ConnectionStatus;
  invites?: ChildParentInvite[];
  familyName: string;
  givenName: string;
};
export type PendingParentType = {
  userId: string;
  email: string;
  status: string;
  invites?: ChildParentInvite[];
};

export type ParentType = ConnectedParentType | PendingParentType;

export type ChildType = {
  parents: ParentType[];
  userId: string;
  canGiveParentInviteReward: boolean;
};

export enum ChildConnectionSource {
  USER_SIGN_UP = "USER_SIGN_UP",
  GUARDIAN_EMAIL_UPDATE = "GUARDIAN_EMAIL_UPDATE",
  BY_EMAIL = "BY_EMAIL",
  INVITE_PARENT_WITH_REWARD = "INVITE_PARENT_WITH_REWARD",
  PARENT_CODE = "PARENT_CODE",
  PARENT_SIGN_UP_OR_EMAIL_UPDATE = "PARENT_SIGN_UP_OR_EMAIL_UPDATE",
  ASSIGNMENT_COMPLETE = "ASSIGNMENT_COMPLETE",
  TEN_SESSIONS_COMPLETE = "TEN_SESSIONS_COMPLETE",
  TEN_SESSIONS_COMPLETE_TUTORING = "TEN_SESSIONS_COMPLETE_TUTORING",
  STUDENT_SIGN_UP_PARENT_EMAIL = "STUDENT_SIGN_UP_PARENT_EMAIL",
  STUDENT_TEN_SESSIONS = "STUDENT_TEN_SESSIONS", // GoStudent tutoring leads variant: https://github.com/senecalabs/senecaweb/issues/14334
  SHARE_PREMIUM_WITH_PARENT = "SHARE_PREMIUM_WITH_PARENT", // https://linear.app/senecalearning/issue/STU-543/estimate-student-to-parent-sharing-complexity
  PARENT_INVITE_EXAM_QUESTIONS = "PARENT_INVITE_EXAM_QUESTIONS",
  PARENT_INVITE_WRONG_ANSWERS = "PARENT_INVITE_WRONG_ANSWERS"
}
